const config = require('../../../json/config.json');
const svgConfig = require('../../../json/svg.json');

export const checkbox = (() => {

    $('.checkbox-container input[type=checkbox]').change(function() {
		var $this				= $( this );
		var $thisCheckboxLabel 	= $this.next( ".checkbox-label" );

		if( $this.is( ":checked" ) ) {
			$thisCheckboxLabel.children( '.checkbox-style' ).addClass( 'checked' );
		} else {
			$thisCheckboxLabel.children( '.checkbox-style' ).removeClass( 'checked' );
		}

	});

})();


// WEBPACK FOOTER //
// ./src/components/inputs/checkbox/checkbox.js